import { useEffect, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header'
import { useDispatch, useSelector } from 'react-redux';
import { logoutSuccessful, userDetailsSelector } from '../../rdxsga/redux/slices/userSlice';
import { useUserAction } from '../../rdxsga/hooks/actions/users/useUserActionHook';
import ApiLoader from '../Loader/ApiLoader';
import { globalLoaderSelector, selectSidebar, toggleSideBar } from '../../rdxsga/redux/slices/themeSlice';
import RightDrawer from './header/RightDrawer';
import { NotificationSocketProvider, useNotificationSocket } from '../../context/NotificationSocketProvider';
import Loader from '../Loader/Loader';
import { selectOngoingOperation } from '../../rdxsga/redux/slices/payslipSlice';
import { APP_URLS } from '../../config';
import { speakLoudly } from '../../helpers/voice/functions';
import ShowRemainderModel from '../../components/common/modals/ShowRemainderModel';
import { useApplicationApi } from '../../rdxsga/hooks/actions/application/useApplicationApiHook';
import { toast } from 'react-toastify';

const DefaultLayout = (props) => {

  const location = useLocation();
  const userAction = useUserAction();
  const { id } = useParams();
  const { remainders } = useNotificationSocket();
  console.log({ remainders });


  const sidebarOpen = useSelector(selectSidebar);
  // const onGoingOperation = useSelector(selectOngoingOperation);
  const globalLoader = useSelector(globalLoaderSelector)
  const userDetails = useSelector(userDetailsSelector);
  const [showRemainderModel, setShowRemainderModel] = useState(false)



  const dispatch = useDispatch();
  const [openRight, setOpenRight] = useState(false);
  const openDrawerRight = () => setOpenRight(true);
  const closeDrawerRight = () => setOpenRight(false);

  const setSidebarOpen = (whattoset) => {
    dispatch({
      type: toggleSideBar.type,
      payload: whattoset
    })
  }
  // const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    //console.log("logout")
    // speakLoudly(`${userDetails?.user?.user.firstName} ${userDetails?.user?.user.lastName}, logging out`);
    userAction.logoutUser();

  };

  const dontShowLoaders = [
    APP_URLS.PROSPECTS.OPEN
  ]



  useEffect(() => {
    // authentication.checkToken();
    //console.log(location.pathname)
    //console.log(dontShowLoaders, { id })
  }, [location])
  return (
    <div className="relative bg-bodywhite font-montserrat dark:bg-boxdark-2 dark:text-whiter">

      {
        !dontShowLoaders.map(d => d.replace(":id", id)).includes(location.pathname) && globalLoader && <div className='absolute w-full h-full bg-transparent backdrop-blur z-999 flex flex-col justify-center items-center'>
          {/* <Loader /> */}
          <ApiLoader />
        </div>
      }

      {/* <!-- ===== Page Wrapper Start ===== --> */}
      <div className="flex h-screen overflow-hidden">
        {/* <!-- ===== Sidebar Start ===== --> */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} handleLogout={handleLogout} />
        {/* <!-- ===== Sidebar End ===== --> */}

        {/* <!-- ===== Content Area Start ===== --> */}
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          {/* <!-- ===== Header Start ===== --> */}
          <Header
            sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} handleLogout={handleLogout}
            openDrawerRight={openDrawerRight} />
          {/* <!-- ===== Header End ===== --> */}

          {/* <!-- ===== Main Content Start ===== --> */}
          <main>
            <div className={`${sidebarOpen || "ml-[50px]"} mx-auto max-w-screen-2xl p-2 md:p-4 2xl:p-6`}>
              {props.children}
            </div>
          </main>
          {/* <ApiLoader /> */}
          {/* <!-- ===== Main Content End ===== --> */}
        </div>
        {/* <!-- ===== Content Area End ===== --> */}
      </div>
      {/* <!-- ===== Page Wrapper End ===== --> */}
      {/* <NotificationSocketProvider> */}
      <RightDrawer
        closeDrawerRight={closeDrawerRight}
        openRight={openRight}
      />
      {/* </NotificationSocketProvider> */}


      {remainders.length > 0 &&

        <ShowRemainderModel
          remaindersData={remainders}
          open={remainders.length > 0}
          confirmText='Completed'
          cancelText='Reschedule'
        />

      }
    </div>
  );
};

export default DefaultLayout;
